import { Email, EmailOutlined, HelpOutlineOutlined } from "@mui/icons-material";
import {
	Alert,
	Box,
	Button,
	Card,
	Divider,
	FormControlLabel,
	Grid,
	Icon,
	IconButton,
	InputAdornment,
	LinearProgress,
	MenuItem,
	Paper,
	Switch,
	Tooltip,
	Typography,
	useMediaQuery,
	useTheme,
} from "@mui/material";
import { add, format, parseISO, subDays } from "date-fns";
import moment from "moment";
import "moment/locale/pt-br";
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import * as yup from "yup";
import { useAuthContext } from "../../../context";
import { useProfile } from "../../../context/ProfileContext";
import { BasicModal, ModalContext, ToastContent, ToolbarAnalysis } from "../../../shared/components";
import { Environment } from "../../../shared/environment";
import { PermissionActionsEnum, PermissionRolesEnum } from "../../../shared/enums/profiles";
import { checkByProfileGuard } from "../../../shared/guards/ProfileGuard";
import { IVFormErros, useVForm, VForm, VTextField } from "../../../shared/forms";
import { VMaskTextField } from "../../../shared/forms/VMaskTextField";
import { useToast } from "../../../shared/hooks";
import { LayoutBaseDePagina } from "../../../shared/layouts";
import { analysisService, Client, IDetalheAnalises, IPlan } from "../../../shared/services/api/analysis/analysisService";
import { PeopleService } from "../../../shared/services/api/people/PeopleService";
import { globalColorInputBackGround, globalColorTytle, globalMaskReal, RangeStates } from "../../../shared/utils";
import { formValidationSchema, IFormData } from "../helpers/validationSchema";

const removeMask = (value?: string | null): string => {
	if (!value || typeof value !== "string") return "";

	return value
		.replace(/\D/g, "")
		.replace(/[^0-9]/g, "")
		.replace(/(\d{1,2})$/, ".$1");
};

const ITEM_HEIGHT = 8;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			height: 150,
			maxHeight: ITEM_HEIGHT * 1 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
};

export const AnalysisHiringPresentation: React.FC = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const analise = searchParams.get("analise") || "";
	const plano = searchParams.get("plano") || "";
	const navigate = useNavigate();
	const { formRef } = useVForm();
	const [isLoading, setIsLoading] = useState(false);
	const [nome, setNome] = useState("");
	const [openModal, setOpenModal] = useState(false);
	const theme = useTheme();
	const smDown = useMediaQuery(theme.breakpoints.down("sm"));
	const [plan, setPlan] = useState("");
	const [validity, setValidity] = useState("12");
	const [documentType, setDocumentType] = useState("cpf");
	const [document, setDocument] = useState("");
	const [confirmEmail, setConfirmEmail] = useState(false);
	const [email, setEmail] = useState("");
	const [listPlans, setListPlans] = useState<IPlan[]>([]);
	const [beginDate, setBeginDate] = useState("");
	const [endDate, setEndDate] = useState("");
	const [termBegin, setTermBegin] = useState("");
	const [baseCalc, setBaseCalc] = useState(0);
	const [calcAssuranceMonthAmount, setCalcAssuranceMonthAmount] = useState(0);
	const [createAnalysis, setCreateAnalysis] = useState("");
	const [modalValidity, setModalValidity] = useState(false);
	const [ValiditYError, setValidityError] = useState("");
	const [prevEmail, setPrevEmail] = useState("");
	const toastHandler = useToast();
	const [isSendClick, SetIsSendClick] = useState(true);
	const [charges, setCharges] = useState(false);
	const { loggedUser } = useAuthContext();
	const { isSuperAdmin } = useProfile();
	const canClickSign = isSuperAdmin || checkByProfileGuard(PermissionRolesEnum.AnalysisOptions, PermissionActionsEnum.ClickSign);
	const clientObject: Client = {
		activeSignature: 0,
		baseRateCalc: "",
		name: "",
		document: "",
		id: "",
		tax_setup_enable: 0,
		tax_setup_limit_default: "",
		tax_setup_limit_min: "",
		tax_setup_limit_max: "",
	};
	const [feeSelect, setFeeSelect] = useState("0,00");
	const [LMISelect, setLMISelect] = useState("18");
	const [LMIAmountSelect, setLMIAmountSelect] = useState("0,00");
	const [paymentMethod, setPaymentMethod] = useState("");

	const [client, setClient] = useState<Client>(clientObject);

	const weeks = Array.from({ length: 49 }, (_, index) => index + 12);

	const handleOpenModal = () => {
		setOpenModal(true);
	};

	const handleChangeClick = (event: React.ChangeEvent<HTMLInputElement>) => {
		SetIsSendClick(event.target.checked);
	};



	useEffect(() => {
		if (termBegin && validity && endDate) {
			const parsedExpireAt: Date = parseISO(termBegin);
			const parsedEndDate: Date = parseISO(endDate);
			const expires: Date = add(parsedExpireAt, {
				months: parseInt(`${validity}`),
			});
			const subtractedExpireDate: Date = subDays(expires, 1);
			const formattedSubtractedExpireDate: string = format(subtractedExpireDate, "yyyy-MM-dd");
			formRef.current?.setFieldValue("expiresAt", formattedSubtractedExpireDate);

			if (subtractedExpireDate.getTime() > parsedEndDate.getTime()) {
				setEndDate(formattedSubtractedExpireDate);
				formRef.current?.setFieldValue("contractEnd", formattedSubtractedExpireDate);
			}
		}
	}, [termBegin, validity, endDate]);

	const handleExpiresAt = (date: string) => {
		const expires = format(add(parseISO(date), { months: parseInt(`${validity}`) }), "yyyy-MM-dd");
		var expires2 = format(subDays(parseISO(expires), 1), "yyyy-MM-dd");
		var d1 = Date.parse(beginDate);
		var d2 = Date.parse(endDate);
		var d3 = Date.parse(termBegin);
		var d4 = Date.parse(createAnalysis);
		var d5 = Date.parse(expires2);

		const diffInMs = d2 - d1;
		const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
		const diffInMs2 = d3 - d4;
		const diffInDays2 = diffInMs2 / (1000 * 60 * 60 * 24);

		if (diffInDays < 90) {
			setValidityError("O periodo mínimo de vigência é de 3 meses");
			setModalValidity(true);
		} else {
			if (diffInDays2 < 0 || diffInDays2 > 30) {
				setValidityError("Data de início de vigência não pode ser menor que data de aprovação da análise ou superior a 30 dias da aprovação");
				setModalValidity(true);
			} else {
				if (d5 > d2) {
					setValidityError("O fim do período de vigência não pode ser superior ao fim do contrato de locação");
					setModalValidity(true);
				} else {
					setEmail("");
					setConfirmEmail(true);
				}
			}
		}
	};

	const handleDocumentType = (document: any) => {
		if (document === "physical") {
			setDocumentType("cpf");
		}
		if (document === "legal") {
			setDocumentType("cnpj");
		}
	};

	const handleCPF = (value: string) => {
		const documento = value.replace(/[^0-9]/g, "");
		const ur = `${Environment.URL_API_CPF}`; //'https://api.cpfcnpj.com.br/548312cf26cd55f10c94de3c123f5c83/2/'

		if (documento === document) {
			toastHandler.present({
				type: "error",
				position: "top-right",
				messageOrContent: <ToastContent title={"Erro "} content={"Documento do locador deve ser diferente do documento do locatário"} />,
			});
			formRef.current?.setFieldValue("lessorCpf", " ");
			formRef.current?.setFieldValue("lessorName", "");
			formRef.current?.setFieldValue("lessorMotherName", "");
		} else {
			PeopleService.getPersonDataByDocument(documento)
				.then((data) => {
					formRef.current?.setFieldValue("lessorName", data.naturalPersonData?.name);
					formRef.current?.setFieldValue("lessorBirthDate", data.naturalPersonData?.birthDate);
					formRef.current?.setFieldValue("lessorMotherName", data.naturalPersonData?.motherName);
				})
				.catch((err) => {
					const messageTitle = "Erro na pesquisa";
					const messageContent = "CPF não localizado na base, verifique se esta correto.";

					toastHandler.present({
						type: "error",
						position: "top-right",
						messageOrContent: <ToastContent title={messageTitle} content={messageContent} />,
					});
				});
		}
	};

	useEffect(() => {
		setIsLoading(true);
		analysisService.getById(`${analise}`).then((result: IDetalheAnalises | Error) => {
			setIsLoading(false);
			if (result instanceof Error) {
				navigate("/analises");
			} else {
				setNome(result.name);
				setDocument(result.document);
				let baseRateCalc = result.baseCalc ? result.baseCalc : "aluguel"; // setando base de calculo de taxas vindo do cliente
				const pplano = result.planlist; //******setando o objeto string dos planos carregandos na result****
				const planos = JSON.parse(pplano); //******convertendo string de planos para objeto**********
				const AutoCompletePlan = planos.find((searchid: IPlan) => searchid.planId === plano); //******localizando o plano dentro do objeto**********

				setListPlans(planos);
				const fee = result.propertyFinally === "residential" ? AutoCompletePlan.residentialFee : AutoCompletePlan.commercialFee;
				setFeeSelect(fee);
				const lmi = AutoCompletePlan.lmi;
				setLMISelect(lmi);
				//console.log("lmi", lmi);
				// setPlan(AutoCompletePlan.plan.id);
				setPlan(AutoCompletePlan.planId);
				setCreateAnalysis(result.createdAt.substring(0, 10));
				setPrevEmail(result.email);
				setClient(result.client as Client);

				const rentMonthsCount = result.rentMonthsCount ? result.rentMonthsCount : 12;
				let feepc = parseFloat(fee) / 100;
				let varBaseCalc = parseFloat(result.rentAmount);
				let varAssuranceMonthAmount = varBaseCalc * feepc;

				if (plano.includes("__charges")) {
					//baseRateCalc === "encargos") {
					console.log("includes... charges.", planos);
					setCharges(true);
					baseRateCalc = "encargos";
					varBaseCalc = parseFloat(result.rentAmount) + parseFloat(result.condominiumAmount) + parseFloat(result.iptuAmount);
					varAssuranceMonthAmount = varBaseCalc * feepc;
				}
				setCalcAssuranceMonthAmount(varAssuranceMonthAmount);
				setBaseCalc(varBaseCalc);
				setTermBegin(moment().format("YYYY-MM-DD"));
				setEndDate(moment().add(rentMonthsCount, "month").format("YYYY-MM-DD"));
				setBeginDate(moment().format("YYYY-MM-DD"));
				setValidity(rentMonthsCount.toString());

				formRef.current?.setData({
					lessorTypePerson: result.lessorTypePerson,
					lessorCpf: result.lessorCpf,
					lessorName: result.lessorName,
					status: "pending",
					lessorBirthDate: result.lessorBirthDate,
					lessorPhone: result.lessorPhone,
					lessorMobilePhone: result.lessorMobilePhone,
					lessorEmail: result.lessorEmail,
					termBegin: moment().format("YYYY-MM-DD"), //'2022-11-26',//apagar
					expiresAt: moment().add(rentMonthsCount, "month").format("YYYY-MM-DD"), //'2023-11-25',//apagar
					contractBegin: moment().format("YYYY-MM-DD"), //'2022-11-26',//apagar
					contractEnd: moment().add(rentMonthsCount, "month").format("YYYY-MM-DD"), //'2023-11-25',//apagar
					paymentMethod: "billet",
					rentMonthsCount,
					addressZipcode: result.addressZipcode,
					propertyFinally: result.propertyFinally,
					propertyType: result.propertyType,
					addressStreet: result.addressStreet,
					addressNumber: result.addressNumber,
					addressCity: result.addressCity,
					addressState: result.addressState,
					addressComplement: result.addressComplement,
					addressDistrict: result.addressDistrict,
					lmi: lmi,
					rentAmount: result.rentAmount,
					lmiAmount: (varBaseCalc * parseInt(lmi)).toFixed(2),
					fee: fee,
					assuranceMonthAmount: varAssuranceMonthAmount.toFixed(2),
				});
			}
		});
	}, []);

	useEffect(() => {
		formRef.current?.getFieldValue("planId") === "" || formRef.current?.getFieldValue("planId") == null
			? formRef.current?.setFieldValue("planId", plan)
			: formRef.current?.setFieldValue("planId", plan);
	}, [plan]);

	useEffect(() => {
		SetIsSendClick(true);

		if (client?.activeSignature != 1) {
			SetIsSendClick(false);
		}

	}, [client]);

	const handleSave = (dados: IFormData) => {
		setConfirmEmail(false);
		dados.planId = plan;
		dados.lessorCpf = dados.lessorCpf.replace(/[^0-9]/g, "");
		dados.lessorPhone = dados.lessorPhone.replace(/[^0-9]/g, "");
		dados.lessorMobilePhone = dados.lessorMobilePhone?.replace(/[^0-9]/g, "");
		dados.sendClick = isSendClick === true ? "true" : "false";
		dados.fee = removeMask(feeSelect);
		dados.assuranceMonthAmount = calcAssuranceMonthAmount.toFixed(2);
		dados.email = email;
		dados.lmi = LMISelect;
		dados.lmiAmount = (baseCalc * parseInt(LMISelect)).toFixed(2);

		console.log("dados antes de enviar", dados);
		delete dados.addressCity;
		delete dados.addressState;
		delete dados.addressDistrict;
		delete dados.addressNumber;
		delete dados.addressZipcode;
		delete dados.addressStreet;

		formValidationSchema
			.validate(dados, { abortEarly: false })
			.then((dadosvalidados) => {
				setIsLoading(true);
				//console.log("dados :", dados);
				const payload = {
					...dadosvalidados,
					charges: charges,
					setup_tax: dadosvalidados.setup_tax === "true",
				};
				analysisService
					.updateById(analise, payload)
					.then((result) => {
						setIsLoading(false);
						if (result instanceof Error) {
							const titleMessage = "Alerta!!";
							const contentMessage = "Erro: " + result?.message;

							toastHandler.present({
								type: "error",
								position: "top-right",
								messageOrContent: <ToastContent title={titleMessage} content={contentMessage} />,
							});
						} else if (result && result?.isExpired) {
							const titleMessage = "Alerta!";
							const contentMessage = "Não foi possível confirmar a contratação, pois a data está expirada dessa ánalise.";

							toastHandler.present({
								type: "warning",
								position: "top-right",
								messageOrContent: <ToastContent title={titleMessage} content={contentMessage} />,
							});
						} else {
							handleOpenModal();
						}
					})
					.catch((errors) => {
						const titleMessage = "Alerta!";
						const contentMessage = errors.response.data.message;
						toastHandler.present({
							type: "warning",
							position: "top-right",
							messageOrContent: <ToastContent title={titleMessage} content={contentMessage} />,
						});
						setIsLoading(false);
					});
			})
			.catch((errors: yup.ValidationError) => {
				const validationErros: IVFormErros = {};

				console.groupCollapsed("❌ Erros de validação do formulário:");
				errors.inner.forEach((error) => {
					if (error.path) {
						validationErros[error.path] = error.message;
						console.log(`• ${error.path}: ${error.message}`);
					}
				});
				console.groupEnd();

				if (errors.errors.length > 0) {
					const titleMessage = "Erro na validação!";
					const contentMessage = "Existem campos obrigatórios ou inválidos.";

					toastHandler.present({
						type: "error",
						position: "top-right",
						messageOrContent: <ToastContent title={titleMessage} content={contentMessage} />,
					});
				}

				formRef.current?.setErrors(validationErros);
			});
	};



	return (
		<LayoutBaseDePagina
			titulo="Análises"
			subtitulo={analise === "novo" ? "Nova análise de crédito" : `Alteração de análise [ ${nome} ]`}
			barraDeFerramentas={
				<ToolbarAnalysis
					clickAnalysis={() => handleExpiresAt(termBegin)}
					showButtonAnalysis={true}
					clickCancel={() => navigate("/analises")}
					clickBack={() => navigate("/analises")}
					textButtonAnalysis={"Finalizar contratação"}
					showButtonCancel={false}
					showButtonProposal={false}
					showButtonEmailresend={false}
					showButtonReAnalysis={false}
				/>
			}
		>
			{openModal && (
				<BasicModal
					isCloseModal={() => setOpenModal(false)}
					isOpenModal={openModal}
					messageType={"success"}
					showButtonCancel={false}
					textButtonConfirm={"OK"}
					onclickConfirm={() => {
						setOpenModal(false), navigate("/analises");
					}}
					IMessage={"Contratação realizada com sucesso !"}
				/>
			)}

			{modalValidity && (
				<ModalContext
					isCloseModal={() => setModalValidity(false)}
					isOpenModal={modalValidity}
					messageType={"error"}
					showButtonCancel={false}
					textButtonConfirm={"Cancelar"}
					onclickConfirm={() => { }}
					ITitle={"Erro de período de vigência"}
					IMessage={[
						<Box style={{ width: "100%" }}>
							<Typography id="modal-modal-description" sx={{ mt: 2, mb: 2, color: "#7d7d7d" }}>
								{ValiditYError}
							</Typography>
							<Typography id="modal-modal-description" sx={{ mt: 2, mb: 2, color: "#7d7d7d" }}>
								Data de aprovação da analise: {moment(createAnalysis).format("L")}
							</Typography>

							<Grid
								container
								item
								sm={12}
								sx={{
									border: "none",
									display: "flex",
									justifyContent: "center",
								}}
								display={"flex"}
								flexDirection={smDown ? "column" : "row"}
								padding={2}
								gap={2}
							>
								<Button
									color="primary"
									disableElevation
									variant={"outlined"}
									startIcon={<Icon> arrow_back_Ico</Icon>}
									onClick={() => {
										setModalValidity(false);
									}}
								>
									{"Voltar"}
								</Button>
							</Grid>
						</Box>,
					]}
				/>
			)}

			{confirmEmail && (
				<ModalContext
					isCloseModal={() => setConfirmEmail(false)}
					isOpenModal={confirmEmail}
					messageType={"alert"}
					showButtonCancel={false}
					textButtonConfirm={"Cancelar"}
					onclickConfirm={() => { }}
					ITitle={"Confirmação de email"}
					IMessage={[
						<Box style={{ width: "100%" }}>
							<Typography id="modal-modal-description" sx={{ mt: 2, mb: 2, color: "#7d7d7d" }}>
								<VForm
									id="formIdSave"
									placeholder="Your placeholder"
									onPointerEnterCapture={() => console.log("Pointer entered")}
									onPointerLeaveCapture={() => console.log("Pointer left")}
									ref={formRef}
									onSubmit={handleSave}
								>
									<Grid container item direction="column" padding={1} spacing={2}>
										<Grid container item direction="row" spacing={1} sx={{ mb: 2 }}>
											<Grid item xs={4} sx={{ textAlign: "right" }}>
												Confirme o email cadastrado :
											</Grid>
											<Grid item xs={6} sx={{ alignItems: "left" }}>
												<Typography variant="inherit" sx={{ fontWeight: "bold" }}>
													{prevEmail}
												</Typography>
											</Grid>
										</Grid>
										<Grid container item direction="row" spacing={2}>
											<Grid item xs={12}>
												<VTextField
													fullWidth
													label="Email do locatário"
													name="email"
													trimEmptySpaces={true}
													disabled={isLoading}
													onChange={(e) => setEmail(e.target.value)}
													InputProps={{
														endAdornment: (
															<InputAdornment position="end">
																<IconButton aria-label="toggle password visibility" edge="end">
																	<EmailOutlined />
																</IconButton>
															</InputAdornment>
														),
													}}
												/>
											</Grid>
										</Grid>
									</Grid>

									<Grid
										container
										item
										sm={12}
										sx={{
											border: "none",
											display: "flex",
											justifyContent: "center",
										}}
										display={"flex"}
										flexDirection={smDown ? "column" : "row"}
										padding={2}
										gap={2}
									>
										<Button
											color="primary"
											disableElevation
											variant={"contained"}
											startIcon={<Icon> checkIcon</Icon>}
											onClick={() => {
												email !== ""
													? formRef.current?.submitForm()
													: toastHandler.present({
														type: "error",
														position: "top-right",
														messageOrContent: (
															<ToastContent title={"Erro de confirmação"} content={"Favor confirmar o email"} />
														),
													});
											}}
										>
											{"Confirmar"}
										</Button>
										<Button
											color="primary"
											disableElevation
											variant={"outlined"}
											startIcon={<Icon> arrow_back_Ico</Icon>}
											onClick={() => {
												setConfirmEmail(false);
											}}
										>
											{"Voltar"}
										</Button>
									</Grid>
								</VForm>
							</Typography>
						</Box>,
					]}
				/>
			)}

			<VForm
				id="formIdSave2"
				placeholder="Your placeholder"
				onPointerEnterCapture={() => console.log("Pointer entered")}
				onPointerLeaveCapture={() => console.log("Pointer left")}
				ref={formRef}
				onSubmit={handleSave}
			>
				{/* ******************************************** */}

				<Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined" sx={{ padding: 2, maxWidth: 1200 }}>
					<Grid container item direction="column" padding={2} spacing={2}>
						{isLoading && (
							<Grid item>
								<LinearProgress variant="indeterminate" />
							</Grid>
						)}
						<Grid container item direction="row" spacing={2}>
							<Grid item xs={11}>
								<Typography variant="h6" color={globalColorTytle}>
									Dados do Imóvel{" "}
								</Typography>
							</Grid>
						</Grid>

						<Grid container item direction="row" spacing={2}>
							<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
								<VTextField fullWidth label="Tipo Imóvel " name="propertyType" disabled={true} />
							</Grid>

							<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
								<VTextField fullWidth label="Finalidade" name="propertyFinally" disabled={true} select>
									<MenuItem value="residential">Residencial</MenuItem>
									<MenuItem value="commercial">Comercial</MenuItem>
								</VTextField>
							</Grid>
							<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
								<VMaskTextField fullWidth label="CEP" name="addressZipcode" disabled={true} mask="cep" />
							</Grid>
						</Grid>

						<Grid container item direction="row" spacing={2}>
							<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
								<VTextField fullWidth label="Rua" name="addressStreet" disabled={true} />
							</Grid>
							<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
								<VTextField fullWidth label="Numero" name="addressNumber" disabled={true} />
							</Grid>
							<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
								<Tooltip title="Digite ou altere o complemento">
									<VTextField
										fullWidth
										label="Complemento * "
										name="addressComplement"
										disabled={isLoading}
										sx={{
											background: globalColorInputBackGround,
										}}
										className="Testecomp"
									/>
								</Tooltip>
							</Grid>
						</Grid>

						<Grid container item direction="row" spacing={2}>
							<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
								<VTextField fullWidth label="Bairro" name="addressDistrict" disabled={true} />
							</Grid>
							<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
								<VTextField fullWidth label="Cidade" name="addressCity" disabled={true} />
							</Grid>
							<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
								<VTextField fullWidth label="Estado" name="addressState" disabled={true} select>
									{RangeStates.map(({ value, label }, key) => (
										<MenuItem value={value}>{label}</MenuItem>
									))}
								</VTextField>
							</Grid>
						</Grid>
					</Grid>

					<Divider />

					<Grid container item direction="column" padding={2} spacing={2}>
						{isLoading && (
							<Grid item>
								<LinearProgress variant="indeterminate" />
							</Grid>
						)}
						<Grid container item direction="row" spacing={2}>
							<Grid item xs={11}>
								<Typography variant="h6" color={globalColorTytle}>
									Dados Locador
								</Typography>
							</Grid>
						</Grid>

						<Grid container item direction="row" spacing={2}>
							<Grid item xs={12} md={4}>
								<VTextField
									fullWidth
									label="Tipo de Locador"
									name="lessorTypePerson"
									disabled={isLoading}
									select
									onChange={(e) => handleDocumentType(e.target.value)}
								>
									<MenuItem value={"physical"}>Fisica</MenuItem>
									<MenuItem value={"legal"}>Juridica</MenuItem>
								</VTextField>
							</Grid>
							{canClickSign && (
								<Grid item xs={12} md={2}>
									<FormControlLabel
										control={
											<Switch
												onChange={handleChangeClick}
												name="sendClick"
												color="primary"
												checked={isSendClick}
												defaultChecked={isSendClick}
												disabled={client?.activeSignature == 1 ? false : true}
											/>
										}
										label="Enviar ClickSign"
									/>
								</Grid>
							)}
						</Grid>

						<Grid container item direction="row" spacing={2}>
							<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
								<VMaskTextField
									fullWidth
									label="Documento"
									name="lessorCpf"
									disabled={isLoading}
									mask={documentType}
									onBlur={(e) => documentType === "cpf" && handleCPF(e.target.value)}
								/>
							</Grid>

							<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
								<VTextField fullWidth label="Nome" name="lessorName" disabled={isLoading} />
							</Grid>

							{documentType === "cpf" && (
								<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
									<VTextField fullWidth label="Dada de nascimento" name="lessorBirthDate" disabled={isLoading} type="date" />
								</Grid>
							)}
						</Grid>

						<Grid container item direction="row" spacing={2}>
							<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
								<VMaskTextField fullWidth label="Celular" name="lessorPhone" disabled={isLoading} mask="cell" />
							</Grid>
							<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
								<VMaskTextField fullWidth label="Telefone" name="lessorMobilePhone" disabled={isLoading} mask="cell" />
							</Grid>
							<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
								<VTextField
									fullWidth
									label="E-mail"
									name="lessorEmail"
									disabled={isLoading}
									trimEmptySpaces={true}
									InputProps={{
										endAdornment: (
											<InputAdornment position="end">
												<IconButton aria-label="toggle password visibility" edge="end">
													<Email />
												</IconButton>
											</InputAdornment>
										),
									}}
								/>
							</Grid>
						</Grid>
					</Grid>

					<Divider />

					<Grid container item direction="column" padding={2} spacing={2}>
						{isLoading && (
							<Grid item>
								<LinearProgress variant="indeterminate" />
							</Grid>
						)}
						<Grid container item direction="row" spacing={2}>
							<Grid item xs={11}>
								<Typography variant="h6" color={globalColorTytle}>
									Plano e Bonificação
								</Typography>
							</Grid>

							<Card
								variant="outlined"
								sx={{
									p: 2,
									borderRadius: 3,
									background: "#fffff",
									border: "1px solid #e0e0e0",
									boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
									width: "100%",
									mt: 2,
								}}
							>
								<Box display="flex" justifyContent="space-between" flexWrap="wrap" gap={2}>
									{(() => {
										const selectedPlan = listPlans.find((element) => element.planId === plan);
										if (!selectedPlan) return null;

										const infoItem = (label: string, value: string | number, bold = false) => (
											<Box flex={1} minWidth={140} display="flex" flexDirection="column">
												<Typography variant="caption" color="text.secondary">
													{label}
												</Typography>
												<Typography variant="body2" fontWeight={bold ? 700 : 500} color={bold ? "primary.main" : "text.primary"} noWrap>
													{value}
												</Typography>
											</Box>
										);

										return (
											<>
												{infoItem("Plano Escolhido", selectedPlan.plan?.description || "-")}
												{infoItem("LMI", `${selectedPlan.lmi} x`)}
												{infoItem("Taxa", selectedPlan.residentialFee || selectedPlan.commercialFee || "-")}
												{infoItem("Valor LMI", `R$ ${globalMaskReal((baseCalc * parseFloat(selectedPlan.lmi)).toFixed(2))}`)}
												{infoItem("Valor Mensal", `R$ ${globalMaskReal(calcAssuranceMonthAmount.toFixed(2))}`, true)}
											</>
										);
									})()}
								</Box>
							</Card>

						</Grid>
					</Grid>

					<Divider />
					<Grid container item direction="column" padding={2} spacing={2}>
						<Grid container item direction="row" spacing={2}>
							<Grid item xs={11}>
								<Typography variant="h6" color={globalColorTytle}>
									Vigência{" "}
								</Typography>
							</Grid>
						</Grid>

						<Grid container item direction="row" spacing={2}>
							<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
								<VMaskTextField fullWidth label="Valor do Aluguel" name="rentAmount" disabled={true} mask="real" />
							</Grid>
							<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
								<VTextField
									fullWidth
									label="Quantidade de meses Vigência"
									name="rentMonthsCount"
									disabled={isLoading}
									onChange={(e) => setValidity(e.target.value)}
									select
								>
									{weeks.map((element, key) => (
										<MenuItem value={element}>{element}</MenuItem>
									))}
								</VTextField>
							</Grid>

							<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
								<VTextField
									fullWidth
									label="Inicio do contrato de locação"
									name="contractBegin"
									disabled={isLoading}
									type="date"
									onChange={(e) => setBeginDate(e.target.value)}
								/>
							</Grid>
						</Grid>

						<Grid container item direction="row" spacing={2}>
							<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
								<VTextField
									fullWidth
									label="Fim do contrato de locação"
									name="contractEnd"
									disabled={isLoading}
									onChange={(e) => setEndDate(e.target.value)}
									type="date"
								/>
							</Grid>
							<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
								<VTextField
									fullWidth
									label="Inicio da Vigencia"
									name="termBegin"
									disabled={isLoading}
									type="date"
									onChange={(e) => setTermBegin(e.target.value)}
								/>
							</Grid>
							<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
								<VTextField fullWidth label="Fim da Vigencia" name="expiresAt" disabled={true} type="date" />
							</Grid>
						</Grid>
					</Grid>

					<Divider />
					<Grid container item direction="column" padding={2} spacing={2}>
						<Grid container item direction="row" spacing={2}>
							<Grid item xs={11}>
								<Typography variant="h6" color={globalColorTytle}>
									Pagamento
								</Typography>
							</Grid>
						</Grid>

						<Grid container item direction="row" spacing={2}>
							<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
								<VTextField
									fullWidth
									label="Forma de pagamento "
									name="paymentMethod"
									disabled={isLoading}
									onChange={(e) => setPaymentMethod(e.target.value)}
									select
								>
									<MenuItem value={"billet"}>Fatura Imobiliária</MenuItem>
									<MenuItem disabled={client.creditCard === "inactive"} value={"credit_card"}>
										Cartão de crédito
									</MenuItem>
								</VTextField>
							</Grid>

							{paymentMethod === "credit_card" && (
								<Grid item xs={12} sm={12} md={8} >
									<Alert severity="warning">
										<Typography variant="caption" sx={{ color: "text.secondary" }}>
											Caso opte por pagamento via cartão de crédito, acrescentar uma taxa de 3,5% na mensalidade.
										</Typography>
									</Alert>
								</Grid>
							)}
						</Grid>
					</Grid>
				</Box>
			</VForm>
		</LayoutBaseDePagina>
	);
};
